/* eslint-disable camelcase */
/*

		"interactionData": {
			"event": "asc_cta_interaction",
			"element_text": "[[eventData.text]]",
			"link_url": "[[eventData.url]]"
		},

		*/

import formObject from '../form/default.json';

const isMobile = () =>
	window?.DDC?.dataLayer?.page?.attributes?.layoutType === 'mobile';

export default {
	events: {
		'ddc.page.view': [
			{
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						{
							logic: {
								mustEqual: {
									'mapping.pagealias.pageType': 'itemlist'
								}
							},
							payload: {
								item_id: '{{REMOVEKEY}}',
								item_number: '{{REMOVEKEY}}',
								item_condition: '{{REMOVEKEY}}',
								item_fuel_type: '{{REMOVEKEY}}',
								item_inventory_date: '{{REMOVEKEY}}',
								item_price: '{{REMOVEKEY}}',
								itemlist_type: '[[fn.getItemlistType()]]'
							}
						},
						{
							logic: {
								mustEqual: {
									'mapping.pagealias.pageType': 'item'
								}
							},
							payload: {
								item_results: '{{REMOVEKEY}}'
							}
						},
						{
							logic: {
								'mapping.pagealias.pageType': 'showroom'
							},
							payload: {
								item_id: '{{EMPTYSTRING}}',
								item_number: '{{EMPTYSTRING}}',
								item_condition: '{{EMPTYSTRING}}',
								item_variant: '{{EMPTYSTRING}}',
								item_color: '{{EMPTYSTRING}}',
								item_type: '{{EMPTYSTRING}}',
								item_fuel_type: '{{EMPTYSTRING}}',
								item_inventory_date: '{{EMPTYSTRING}}',
								item_price: '{{EMPTYSTRING}}'
							}
						}
					],
					event: 'asc_pageview',
					item_results: '[[vehicleResultCount]] >> {{NULL}}'
				},
				trigger: ['initializeProps', 'srp_view', 'vdp_view']
			}
		],
		'ddc.slideshow.click': [
			{
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '[[eventData.name]]',
					event_action: 'click',
					event_action_result: 'redirect',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			}
		],
		'ddc.slideshow.pagerClick': [
			{
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: ({
						eventData: { currentItem, destinationIndex }
					}) =>
						Number(destinationIndex) - currentItem >= 0
							? 'increase'
							: 'decrease',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			}
		],
		'ddc.link.navClick': [
			{
				logic: [
					({ eventData }) =>
						['ws-navigation', 'navigation-default'].includes(
							eventData?.widgetName
						) &&
						!eventData?.hasChildren &&
						!eventData?.isChildLink &&
						eventData?.position === 'topNav'
				],
				payload: {
					event: 'asc_menu_interaction',
					element_text: '[[eventData.linkText]]',
					element_type: 'menu',
					element_subtype: 'hyperlink',
					event_action: 'click',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					]
				}
			},
			{
				logic: [
					{
						isChildLink: true,
						position: 'topNav'
					}
				],
				payload: {
					event: 'asc_menu_interaction',
					element_text: '[[eventData.linkText]]',
					element_type: 'menu',
					element_subtype: 'hyperlink',
					event_action: 'click',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					]
				}
			}
		],
		'ddc.link.generic': [
			{
				logic: [
					{
						location: 'footer'
					}
				],
				payload: {
					event: 'asc_menu_interaction',
					element_subtype: 'hyperlink',
					element_text: '[[eventData.text]]',
					element_type: 'footer',
					event_action: 'click',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					]
				}
			},
			{
				logic: [
					{
						widgetName: 'ws-content-cta'
					},
					{
						widgetName: 'ws-vehicle-ctas'
					},
					{
						widgetName: 'links-list'
					}
				],
				payload: {
					event: 'asc_cta_interaction',
					affiliation: 'dealer_dot_com',
					element_color:
						'[[eventData.backgroundColor]] >> {{EMPTYSTRING}}', // should this be the getComputedColor or what? ignoring for now
					element_order: ({ eventData: { ctaIndex } }) =>
						ctaIndex || ctaIndex === 0 ? ctaIndex : '', // this widget only has one thing so order does not make sense
					element_text: '[[eventData.text]]',
					element_type: 'body',
					element_subtype: 'cta_button',
					event_action: 'click',
					event_action_result: ({ eventData: { url } = {} }) => {
						// eslint-disable-next-line no-script-url
						if (url === 'javascript:void(0);') {
							return 'open';
						} else if (url?.startsWith?.('#')) {
							return 'shown';
						} else {
							return 'redirect';
						}
					},
					link_url: ({ eventData: { url } = {} }) =>
						// eslint-disable-next-line no-script-url
						url === 'javascript:void(0);' ? '#' : url,
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: [
					({ eventData }) =>
						['ws-navigation', 'navigation-default'].includes(
							eventData?.widgetName
						) &&
						!eventData?.attributes?.class?.includes(
							'nav-with-children'
						) &&
						!isMobile()
				],
				payload: undefined
			},
			{
				logic: [
					({
						eventData: {
							location,
							widgetName,
							url,
							isHamburgerMenu
						}
					}) =>
						isMobile() &&
						location === 'mainNav' &&
						widgetName === 'navbar-default' &&
						url === '#' &&
						isHamburgerMenu
				],
				payload: {
					event: 'asc_menu_interaction',
					element_subtype: 'hamburger_menu',
					element_text: '[[eventData.attributes.aria-label]]',
					element_type: 'menu',
					event_action: 'open',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					]
				}
			},
			{
				logic: [
					({ eventData }) =>
						['ws-navigation', 'navigation-default'].includes(
							eventData?.widgetName
						) &&
						eventData?.location === 'mainNav' &&
						isMobile() &&
						eventData?.url === '#' &&
						eventData?.text !== '#'
				],
				payload: {
					event: 'asc_menu_interaction',
					element_subtype: 'toggle',
					element_text: '[[eventData.text]]',
					element_type: 'menu',
					event_action: 'slide',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					]
				}
			},
			{
				logic: [
					({ eventData }) =>
						['ws-navigation', 'navigation-default'].includes(
							eventData?.widgetName
						) &&
						eventData?.location === 'mainNav' &&
						eventData?.attributes?.['data-toggle'] === 'dropdown'
				],
				payload: {
					event: 'asc_menu_interaction',
					element_subtype: 'nav_tab',
					element_text: '[[eventData.text]]',
					element_type: 'menu',
					event_action: 'open',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					]
				}
			},
			{
				logic: [
					{
						widgetName: 'slideshow-background',
						mustInclude: {
							'eventData.attributes.class': 'prev'
						}
					},
					{
						widgetName: 'slideshow-default',
						mustInclude: {
							'eventData.attributes.class': 'prev'
						}
					},
					{
						widgetName: 'slideshow-carousel',
						mustInclude: {
							'eventData.attributes.class': 'prev'
						}
					}
				],
				payload: {
					media_type: 'gallery',
					event_action_result: 'decrease',
					shared: [
						'[[mapping.configuration.sharedPayloads.oldSlideshows]]',
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: [
					{
						widgetName: 'slideshow-background',
						mustInclude: {
							'eventData.attributes.class': 'next'
						}
					},
					{
						widgetName: 'slideshow-default',
						mustInclude: {
							'eventData.attributes.class': 'next'
						}
					},
					{
						widgetName: 'slideshow-carousel',
						mustInclude: {
							'eventData.attributes.class': 'next'
						}
					}
				],
				payload: {
					media_type: 'gallery',
					event_action_result: 'increase',
					shared: [
						'[[mapping.configuration.sharedPayloads.oldSlideshows]]',
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.widgetName': 'promotions-listing',
						'eventData.attributes.class': 'slick-prev'
					}
				},
				payload: {
					media_type: 'offer',
					event_action_result: 'decrease',
					shared: [
						'[[mapping.configuration.sharedPayloads.oldSlideshows]]',
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.widgetName': 'promotions-listing',
						'eventData.attributes.class': 'slick-next'
					}
				},
				payload: {
					media_type: 'offer',
					event_action_result: 'increase',
					shared: [
						'[[mapping.configuration.sharedPayloads.oldSlideshows]]',
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.widgetName': 'promotions-listing'
					},
					mustNotInclude: {
						'eventData.attributes.class': [
							'slick-prev',
							'slick-next'
						]
					}
				},
				payload: {
					media_type: 'offer',
					link_url: '[[eventData.url]]',
					creative_name:
						'[[eventData.trackingLabel]] >> [[eventData.text]]',
					event_action_result: 'redirect',
					shared: [
						'[[mapping.configuration.sharedPayloads.oldSlideshows]]',
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: {
					isTelephonicUrl: true
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.clickToCall]]'
					]
				}
			},
			{
				logic: [
					{
						mustEqual: {
							'eventData.url': '{{EMPTYSTRING}}'
						}
					},
					{
						url: '#'
					},
					{
						'eventData.attributes.class': 'ui-button-submit'
					},
					{
						widgetName: 'ws-inv-facets'
					}
				]
			}
		],
		'ddc.video.play': [
			{
				logic: [
					{
						mustNotEqual: {
							'eventData.autoplay': true
						}
					}
				],
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'video',
					link_url: '[[eventData.videoSource]]',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: 'play',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			}
		],
		'ddc.video.milestone': [
			{
				logic: {
					'eventData.videoMilestone': 'complete',
					mustNotEqual: {
						'eventData.autoplay': true
					}
				},
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'video',
					link_url: '[[eventData.videoSource]]',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: 'complete',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			}
		],
		widgetUserEvent: [
			{
				logic: {
					'eventData.widgetName': 'ws-inv-facets',
					'eventData.elementCTA': 'Text input',
					'eventData.result': 'Results updated with facet added'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_element_configuration',
					element_title: '[[eventData.facetId]]',
					element_text: '[[eventData.facetTitle]]',
					element_type: 'search_tool',
					element_value: '[[eventData.fieldValue]]',
					element_state: '{{EMPTYSTRING}}',
					element_subtype: 'input_field',
					event_action_result: 'search',
					event_action: 'click'
				}
			},
			{
				logic: {
					'eventData.widgetName': 'ws-inv-facets',
					'eventData.elementCTA': 'Range Slider',
					'eventData.result': 'Results updated with facet added'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_element_configuration',
					element_title: '[[eventData.facetId]]',
					element_text: '[[eventData.facetTitle]]',
					element_type: 'search_tool',
					element_value: '[[eventData.fieldValue]]',
					element_state: '{{EMPTYSTRING}}',
					element_subtype: 'toggle',
					event_action_result: 'search',
					event_action: 'click'
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.widgetName': 'ws-inv-facets',
						'eventData.element': 'selection',
						'eventData.result': 'Results updated with facet added'
					}
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_element_configuration',
					element_title: '[[eventData.facetId]]',
					element_text: '[[eventData.facetTitle]]',
					element_type: 'search_tool',
					element_value: '[[eventData.fieldValue]]',
					element_state: 'active',
					element_subtype: 'inline_menu',
					event_action_result: 'search',
					event_action: 'click'
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.widgetName': 'ws-inv-facets',
						'eventData.element': 'selection',
						'eventData.result': 'Results updated with facet removed'
					}
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_element_configuration',
					element_title: '[[eventData.facetId]]',
					element_text: '[[eventData.facetTitle]]',
					element_type: 'search_tool',
					element_value: '[[eventData.fieldValue]]',
					element_state: 'inactive',
					element_subtype: 'inline_menu',
					event_action_result: 'search',
					event_action: 'click'
				}
			},
			{
				logic: {
					widgetName: 'ws-inv-filters',
					result: 'Results updated with facet added'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_element_configuration',
					element_title: '{{EMPTYSTRING}}',
					element_text: '{{EMPTYSTRING}}',
					element_type: 'search_tool',
					element_value: '[[eventData.fieldValue]]',
					element_state: '{{EMPTYSTRING}}',
					element_subtype: 'cta_button',
					event_action_result: 'search',
					event_action: 'click'
				}
			},
			{
				logic: {
					widgetName: 'ws-media-viewer',
					result: 'Opens gallery modal'
				},
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: 'open',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-specials',
					action: 'clicked',
					element: 'Carousel pause button'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'stop',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: {
					widgetName: 'ws-specials',
					action: 'clicked',
					element: 'Carousel play button'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'play',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: ({ eventData: { widgetName, action, element } }) =>
					widgetName === 'ws-specials' &&
					action === 'clicked' &&
					element === 'Carousel next slide button' &&
					!isMobile(),
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'increase',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: ({ eventData: { widgetName, action, element } }) =>
					widgetName === 'ws-specials' &&
					action === 'clicked' &&
					element === 'Carousel next slide button' &&
					isMobile(),
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'swipe_left',
					event_action_result: 'increase',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: ({ eventData: { widgetName, action, element } }) =>
					widgetName === 'ws-specials' &&
					action === 'clicked' &&
					element === 'Carousel previous button' &&
					!isMobile(),
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'decrease',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: ({ eventData: { widgetName, action, element } }) =>
					widgetName === 'ws-specials' &&
					action === 'clicked' &&
					element === 'Carousel previous button' &&
					isMobile(),
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'swipe_right',
					event_action_result: 'decrease',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: {
					widgetName: 'ws-model-selector',
					action: 'clicked',
					element: 'Next vehicle arrow'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'increase',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: {
					widgetName: 'ws-model-selector',
					action: 'clicked',
					element: 'Prev vehicle arrow'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'decrease',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: {
					widgetName: 'ws-specials',
					action: 'clicked',
					result: 'Opened dialog'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'popup',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: {
					widgetName: 'ws-specials',
					action: 'clicked',
					result: 'Closed dialog'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					event: 'asc_media_interaction',
					event_action: 'click',
					event_action_result: 'close',
					media_type: 'slider',
					affiliation: 'dealer_dot_com',
					creative_name: '{{EMPTYSTRING}}',
					link_url: '{{EMPTYSTRING}}'
				}
			},
			{
				logic: {
					widgetName: 'ws-model-selector',
					mustInclude: {
						'eventData.action': 'swipe'
					}
				},
				payload: ({ eventData: { result } }) => ({
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'slider',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action:
						result === 'Move to previous element in carousel'
							? 'swipe_right'
							: 'swipe_left',
					event_action_result:
						result === 'Move to previous element in carousel'
							? 'decrease'
							: 'increase',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				})
			},
			{
				logic: {
					widgetName: 'ws-rec-vehicles',
					mustInclude: {
						'eventData.action': 'swiped'
					}
				},
				payload: ({ eventData: { currentIndex, previousIndex } }) => {
					let event_action = 'click';
					if (
						Date.now() -
							(window?.DDC?.WidgetData?.['ws-tagging']
								.swipeTimestamp || 0) <
						1000
					) {
						// if a swipe happened in the last 1 second
						event_action =
							currentIndex >= previousIndex
								? 'swipe_left'
								: 'swipe_right';
					}
					return {
						event: 'asc_media_interaction',
						affiliation: 'dealer_dot_com',
						media_type: 'gallery',
						link_url: '{{EMPTYSTRING}}',
						creative_name: '{{EMPTYSTRING}}',
						event_action,
						event_action_result:
							currentIndex >= previousIndex
								? 'increase'
								: 'decrease',
						shared: [
							'[[mapping.configuration.sharedPayloads.sharedProps]]',
							'[[mapping.configuration.sharedPayloads.vehicleData]]'
						]
					};
				}
			},
			{
				logic: {
					widgetName: 'model-selector',
					action: 'swipe'
				},
				payload: ({ eventData: { direction } }) => ({
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'slider',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action:
						direction === 'right' ? 'swipe_right' : 'swipe_left',
					event_action_result:
						direction === 'right' ? 'decrease' : 'increase',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				})
			},
			{
				logic: {
					widgetName: 'model-selector',
					action: 'click',
					result: 'next'
				},
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'slider',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: 'increase',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'model-selector',
					action: 'click',
					result: 'previous'
				},
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'slider',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: 'decrease',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'model-selector',
					action: 'click',
					result: 'dot'
				},
				payload: ({ eventData: { direction } }) => ({
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'slider',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					event_action_result: direction,
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					]
				})
			}
		],
		'ddc.form.change': [
			{
				logic: ({ eventData }) => eventData.isLead === true,
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
					],
					event: 'asc_form_engagement',
					comm_status: 'engage'
				}
			},
			{
				logic: {
					linkType: 'select-one',
					// Worth noting that this event is being pushed from ws-inv-filters despite the name being set to ws-inv-listing
					widgetName: 'ws-inv-listing'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_element_configuration',
					element_title: '{{EMPTYSTRING}}',
					element_text: '{{EMPTYSTRING}}',
					element_type: 'search_tool',
					element_value: '[[eventData.label]]',
					element_state: '{{EMPTYSTRING}}',
					element_subtype: 'dropdown',
					event_action_result: 'search',
					event_action: 'click'
				}
			}
		],
		'ddc.dialog.closed': [
			{
				logic: ({ eventData }) => eventData.hasForm,
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
					],
					event: 'asc_form_engagement',
					comm_status: 'close'
				}
			}
		],
		'ddc.form.initiation': {
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]',
					'[[mapping.configuration.sharedPayloads.vehicleData]]',
					'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
				],
				event: 'asc_form_engagement',
				comm_status: 'start'
			}
		},
		'ddc.form.submission': [
			{
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
					],
					event: 'asc_form_engagement',
					comm_status: 'send'
				}
			}
		],
		'ddc.form.confirmation': [
			{
				logic: {
					validate: true
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
					],
					comm_outcome: 'send',
					element_text:
						'[[eventData.initiatingClickText]] >> {{EMPTYSTRING}}',
					event: 'asc_form_submission',
					page_type: '[[mapping.pagealias-referral.pageType]]',
					submission_id: '[[eventData.formEventId]]'
				},
				trigger: [
					'incentiveEvent',
					'specialFormSubmission',
					'appointmentFormSubmission',
					'otherFormSubmission'
				]
			}
		],
		'ddc.inventory.filterSearch': {
			logic: {
				mustExist: '[[eventData.queryFacets.search]]'
			},
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]'
				],
				event: 'asc_element_configuration',
				element_title: '{{EMPTYSTRING}}',
				element_text: '{{EMPTYSTRING}}',
				element_subtype: 'input_text',
				element_type: 'search_tool',
				element_value: '[[eventData.queryFacets.search]]',
				element_state: '{{EMPTYSTRING}}',
				item_results: '[[eventData.resultCount]]'
			}
		},
		specialsEvent: [
			{
				logic: {
					specialCtaType: 'dialog',
					specialFeature: 'specials_campaign_manager',
					specialEvent: 'click'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_special_offer',
					promotion_name: '[[eventData.specialId]]',
					department: 'specials',
					product_name: '[[eventData.specialHeading]]',
					element_position: '[[eventData.specialPlacementType]]',
					flow_outcome: 'proceed'
				}
			},
			{
				logic: [
					({ eventData }) =>
						['slideshow', 'banner', 'listing'].includes(
							eventData?.specialPlacementType
						) && eventData?.specialType === 'click'
				],
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]'
					],
					event: 'asc_special_offer',
					promotion_name: '[[eventData.title]]',
					department: ({ eventData: { specialCategory } }) => {
						if (
							['Vehicle', 'Incentive', 'Event'].includes(
								specialCategory
							)
						) {
							return 'sales';
						}
						if (['Service', 'Parts'].includes(specialCategory)) {
							return specialCategory.toLowerCase();
						}
						return 'unknown';
					}
				}
			}
		]
	},
	triggerEvents: {
		srp_view: {
			logic: {
				mustEqual: {
					'mapping.pagealias.pageType': 'itemlist'
				}
			},
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]'
				],
				item_color: '',
				item_make: '',
				item_model: '',
				item_type: '',
				item_variant: '',
				item_year: '',
				event: 'asc_itemlist_pageview',
				item_results: '[[vehicleResultCount]] >> {{NULL}}',
				itemlist_type: '[[fn.getItemlistType()]]'
			}
		},
		vdp_view: {
			logic: {
				mustEqual: {
					'mapping.pagealias.pageType': 'item'
				}
			},
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]',
					'[[mapping.configuration.sharedPayloads.vehicleData]]'
				],
				vdp_count: 1,
				event: 'asc_item_pageview'
			}
		},
		initializeProps: {
			payload: {
				events: '[[window.asc_datalayer.events]]',
				items: '[[fn.getVehicleItems()]]',
				measurement_ids: '[[window.asc_datalayer.measurement_ids]]',
				affiliation: 'dealer_dot_com',
				currency: 'usd',
				language: '[[fn.getLanguage()]]',
				oem_brand: '[[fn.getBrand()]]',
				oem_code: '12345',
				store_name: '[[DDC.dataLayer.site.siteInfo.dealerId]]'
			},
			configuration: {
				when: 'first'
			},
			sender: 'asc_datalayer'
		},
		incentiveEvent: {
			logic: {
				customFormId: 'incentives-lead-default'
			},
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]'
				],
				event: 'asc_special_offer',
				promotion_name:
					'[[DDC.dataLayer.confirmation.incentiveTitle]] >> [[DDC.dataLayer.confirmation.incentiveShortTitle]]',
				department: 'sales',
				element_position: 'popup',
				flow_outcome: 'success',
				submission_id: '[[eventData.formEventId]]'
			}
		},
		specialFormSubmission: {
			logic: {
				mustExist: '[[mapping.form.event.[[eventData.trackingId]]]]'
			},
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]',
					'[[mapping.configuration.sharedPayloads.vehicleData]]',
					'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
				],
				comm_outcome: 'send',
				element_text:
					'[[eventData.initiatingClickText]] >> {{EMPTYSTRING}}',
				event: '[[mapping.form.event.[[eventData.trackingId]]]]',
				page_type: '[[mapping.pagealias-referral.pageType]]',
				submission_id: '[[eventData.formEventId]]'
			}
		},
		appointmentFormSubmission: {
			logic: {
				mustExist:
					'[[mapping.form.appointment.[[eventData.trackingId]]]]'
			},
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]',
					'[[mapping.configuration.sharedPayloads.vehicleData]]',
					'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
				],
				comm_outcome: 'appt_booked',
				element_text:
					'[[eventData.initiatingClickText]] >> {{EMPTYSTRING}}',
				event: '[[mapping.form.appointment.[[eventData.trackingId]]]]',
				page_type: '[[mapping.pagealias-referral.pageType]]',
				submission_id: '[[eventData.formEventId]]'
			}
		},
		otherFormSubmission: {
			logic: [
				({ eventData: { trackingId } }) =>
					!Object.keys(formObject.department).includes(trackingId)
			],
			payload: {
				shared: [
					'[[mapping.configuration.sharedPayloads.sharedProps]]',
					'[[mapping.configuration.sharedPayloads.vehicleData]]',
					'[[mapping.configuration.sharedPayloads.formSubmissionData]]'
				],
				comm_outcome: 'unknown',
				element_text:
					'[[eventData.initiatingClickText]] >> {{EMPTYSTRING}}',
				event: 'asc_form_submission_other',
				page_type: '[[mapping.pagealias-referral.pageType]]',
				submission_id: '[[eventData.formEventId]]'
			}
		}
	}
};
